import { initEventTracking } from 'lib/eventTracking'
import { State } from './types'
import { AuthAction, AuthActionTypes } from './auth.actions'

const initialState: State = {
  user: null,
  loading: true,
  darkMode: false,
  permissions: {
    all_privileges: false,
  },
  account: {
    allow_approval: false,
    logo_slug: null,
  },
  features: {
    approval: '',
    'new-submission-history-ui': false,
  },
  bootstrapping: false,
  bootstrapComplete: false,
}

export function Auth(state = initialState, action: AuthAction): State {
  switch (action.type) {
    case AuthActionTypes.BOOTSTRAP_COMPLETE:
      return {
        ...state,
        bootstrapping: false,
        bootstrapComplete: true,
      }
    case AuthActionTypes.USER_LOGGED_IN: {
      const { user, currentAccount, features } = action.payload

      if (!user.permissions.length) {
        user.permissions = Object.values(user.permissions)
      }

      initEventTracking(user, currentAccount)

      return {
        ...state,
        user,
        account: currentAccount,
        loading: false,
        features: {
          ...state.features,
          ...features.reduce(
            (memo, item) => ({
              ...memo,
              [item]: true,
            }),
            {},
          ),
        },
        permissions: user.permissions.reduce(
          (memo, item) => ({
            ...memo,
            [item]: true,
          }),
          {
            all_privileges: false,
          },
        ),
      }
    }

    case AuthActionTypes.NOT_AUTHENTICATED:
      return {
        ...state,
        user: null,
        loading: false,
        bootstrapping: false,
      }

    case AuthActionTypes.LOGOUT:
      return {
        ...initialState,
        user: null,
        loading: false,
        bootstrapping: false,
        /**
         * We want to keep the bootstrap state because we need to know
         * if bootstrap has completed (failed or not) in order to show
         * the login page.
         * */

        bootstrapComplete: state.bootstrapComplete,
      }

    case AuthActionTypes.UPDATE_COMPANY_INFO:
      return {
        ...state,
        account: action.payload,
      }

    default:
      return state
  }
}
